import React, { useContext, useEffect } from 'react';
import { PageContext } from '../providers/page-provider';
import { HealthAssesment } from '../providers/health-assesment-provider';
import { HealthAssesmentCalculator } from '../layouts/health-assesment-calculator';

import {
  Question,
  InputPercentagelabeled,
  StepSummary,
  StepSlider,
  MultiStepSlider
} from '../components'

export const StepOne = () => {
  const { handleNextPage } = useContext(PageContext);
  const { addHealthAssesmentData, healthAssesmentData } = useContext(HealthAssesment);
  const titleStep = "AR Costs";
  const summaryStep = "First, let's get an understanding of how much you're spending on Accounts Receivable.";
  const tooltip = "Accounts Receivable costs are a key factor in determine your overall AR health. Measuring the amount you spend on basic AR functions and comparing those costs against key revenue metrics provides insight into the efficiency of your finance operations.";
  const ach = parseFloat(healthAssesmentData.arCosts.ach) || 0;
  const pc = parseFloat(healthAssesmentData.arCosts.pc) || 0;
  const cc = parseFloat(healthAssesmentData.arCosts.cc) || 0;
  const other = parseFloat(healthAssesmentData.arCosts.other) || 0;

  useEffect(() => {

  }, [])

  const handleNextClick = () => {
    handleNextPage({from: "STEP_ONE", to: "STEP_TWO"});
  };

  const handleChangeInput = (question) => (event) => {
    let { name, value } = event.target;

    if (value === "") {
      value = 0;
    }

    value = parseFloat(value);
    addHealthAssesmentData({question, name, value});
    setSliderHandle(name, value);
    const sum = healthAssesmentData.arCosts.ach + healthAssesmentData.arCosts.pc + healthAssesmentData.arCosts.cc + healthAssesmentData.arCosts.other;

    if (sum < 100) {
      const remaining = 100 - sum;
      const total = remaining + healthAssesmentData.arCosts.other;
      addHealthAssesmentData({question: "arCosts", name: "other", value: total});
    }
  }

  const handleChange = (question) => (event) => {
    let { name, value } = event.target;
    value = parseFloat(value);
    addHealthAssesmentData({question, name, value});
  }

  const setSliderHandle = (name, value) => {
    const rangeSlider = document.getElementById("multi-slider");
    if (isNaN(value)) {
      value = 0;
    }
    const ach = parseFloat(healthAssesmentData.arCosts.ach) || 0;
    const pc = parseFloat(healthAssesmentData.arCosts.pc) || 0;
    const cc = parseFloat(healthAssesmentData.arCosts.cc) || 0;
    const other = parseFloat(healthAssesmentData.arCosts.other) || 0;
    const sum = healthAssesmentData.arCosts.ach + healthAssesmentData.arCosts.pc + healthAssesmentData.arCosts.cc + healthAssesmentData.arCosts.other;
    const remaining = 100 - sum;

    if (name === "ach") {
      rangeSlider.noUiSlider.set([
        value,
        value + pc,
        value + pc + cc,
        value + pc + cc + other + remaining
      ]);
    } else if (name === "pc") {
      rangeSlider.noUiSlider.set([
        ach,
        ach + value,
        ach + value + cc,
        ach + value + cc + other + remaining
      ]);
    } else if (name === "cc") {
      rangeSlider.noUiSlider.set([
        ach,
        ach + pc,
        ach + pc + value,
        ach + pc + value + other + remaining
      ]);
    } else if (name === "other") {
      rangeSlider.noUiSlider.set([
        ach,
        ach + pc,
        ach + pc + cc + remaining,
        ach + pc + cc + value + remaining
      ]);
    }
  }

  const disableButton = () => {
    const paymentMixSum = ach + pc + cc + other;
    return paymentMixSum !== 100;
  }

  return (
    <HealthAssesmentCalculator>
      <div className="fieldset step-one">
        <StepSummary stepNumber="1" stepTitle={titleStep} stepInfo={summaryStep} hasTooltip={true} tooltipText={tooltip}/>
        <div className="questions">
          <div className="column-left">
            <Question>What is your payment mix in terms of volume of revenue?</Question>
            <div className="payment-mix">
              <div className="column">
                <InputPercentagelabeled
                  className="ach"
                  name="ach"
                  onChange={handleChangeInput("arCosts")}
                  value={healthAssesmentData.arCosts.ach}>
                  ACH
                </InputPercentagelabeled>
                <InputPercentagelabeled
                  className="paper-checks"
                  name="pc"
                  onChange={handleChangeInput("arCosts")}
                  value={healthAssesmentData.arCosts.pc}>
                  Paper Checks
                </InputPercentagelabeled>
              </div>
              <div className="column">
                <InputPercentagelabeled
                  className="credit-card"
                  name="cc"
                  onChange={handleChangeInput("arCosts")}
                  value={healthAssesmentData.arCosts.cc}>
                  Credit Card
                </InputPercentagelabeled>
                <InputPercentagelabeled
                  className="other"
                  name="other"
                  onChange={handleChangeInput("arCosts")}
                  value={healthAssesmentData.arCosts.other}>
                  Other
                </InputPercentagelabeled>
              </div>
            </div>
            <MultiStepSlider
              onChange={handleChange("arCosts")}
              idSlider="multi-slider"
              idValue="multi-value"
              achValue={healthAssesmentData.arCosts.ach}
              pcValue={healthAssesmentData.arCosts.pc}
              ccValue={healthAssesmentData.arCosts.cc}
              otherValue={healthAssesmentData.arCosts.other}
            />
          </div>
          <div className="column-right">
            <div className="right-container">
              <Question>What is your credit card rate?</Question>
              <StepSlider
                step={0.01}
                min={0.01}
                max={4}
                minValue="0%"
                maxValue="4%"
                currency={false}
                valueType="%"
                name="b"
                initalValue={healthAssesmentData.arCosts.b}
                onChange={handleChange("arCosts")}
                idSlider="1b-slide"
                idValue="1b-value"
              />

              <Question>What recurring monthly costs do you incur for AR (lockbox, accounting software, etc)?</Question>
              <StepSlider
                min={1}
                max={500}
                minValue="<$1K"
                maxValue="$500K+"
                currency={true}
                valueType="K"
                name="c"
                initalValue={healthAssesmentData.arCosts.c}
                onChange={handleChange("arCosts")}
                idSlider="1c-slide"
                idValue="1c-value"
              />
            </div>
          </div>

          <footer>
            <button disabled={disableButton()} className="btn-white-normal" onClick={handleNextClick}>Next Step <i className="fa fa-angle-right"></i></button>
          </footer>
        </div>
      </div>
    </HealthAssesmentCalculator>
  )
}
